export default __webpack_public_path__ + "bf60da6838945466ad889dd6b32d324a.ttf";